import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const EarningsIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <path
                        fill="currentColor"
                        d="M18.8,15.9H2V4.8h16.8V15.9z M3.2,14.7h14.4V6H3.2V14.7z"
                    />
                </g>
                <g>
                    <polygon
                        fill="currentColor"
                        points="22,19.2 5.8,19.2 5.8,18 20.8,18 20.8,8.7 22,8.7 		"
                    />
                </g>
                <g>
                    <path
                        fill="currentColor"
                        d="M10.4,13.4c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C13.4,12,12,13.4,10.4,13.4z
                        M10.4,8.5c-1,0-1.9,0.8-1.9,1.9s0.8,1.9,1.9,1.9s1.9-0.8,1.9-1.9S11.4,8.5,10.4,8.5z"
                    />
                </g>
                <g>
                    <rect
                        x="4.2"
                        y="13"
                        fill="currentColor"
                        width="1.6"
                        height="1.2"
                    />
                </g>
                <g>
                    <rect
                        x="14.9"
                        y="6.5"
                        fill="currentColor"
                        width="1.6"
                        height="1.2"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
